module.exports = __webpack_public_path__ + "img/gongzheng_pic.ccb6cb54.png";